import { type FC } from 'react';
import cn from 'classnames';

import { toShortNumFormat } from '@/common/lib/toShortNumFormat';
import { Picture } from '@/components/ui/Picture/Picture';

import cashPng from '/img/icons/cash-large.png';
import cashWebp from '/img/icons/cash-large.webp';
import starPng from '/img/icons/star-large.png';
import starWebp from '/img/icons/star-large.webp';
import tgemPng from '/img/tgem.png';
import tgemWebp from '/img/tgem.webp';

interface RewardProps {
  kind?: 'Cash' | 'str' | 'tgem';
  value?: number;
  className?: string;
}

const Reward: FC<RewardProps> = ({ className, kind, value }) => {
  const images = {
    Cash: {
      png: cashPng,
      webp: cashWebp,
    },
    str: {
      png: starPng,
      webp: starWebp,
    },
    tgem: {
      png: tgemPng,
      webp: tgemWebp,
    },
  };

  if (!kind) {
    return null;
  }

  const image = images[kind];

  return (
    image && (
      <div className={cn('flex items-center gap-1', className)}>
        <Picture
          className="w-10 h-10"
          img={image.png}
          webp={image.webp}
          alt={kind}
        />
        <span className="text-[2rem] leading-none font-extrabold">
          {toShortNumFormat(value || 0)}
        </span>
      </div>
    )
  );
};

export { Reward };
